import { render, staticRenderFns } from "./ZoneHelpModal.vue?vue&type=template&id=2f70c889&scoped=true&"
import script from "./ZoneHelpModal.vue?vue&type=script&lang=ts&"
export * from "./ZoneHelpModal.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneHelpModal.vue?vue&type=style&index=0&id=2f70c889&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70c889",
  null
  
)

export default component.exports